<template>
  <div id="articles">
    <div class="article_box mainWidth">
        <div class="title">
            新闻列表
        </div>
          <mu-row   v-for="news in news" :key="news.title" class="news_box">
            <mu-col class="" width="70" tablet="70" desktop="70">

              <div class="">
                <div class="news_title oneLine">
                  {{news.title}}
                  </div>
                <div class="news_abstract oneLine">
                  {{news.contents}}
                  </div>
                <div class="news_other">
                  <span class="icon_creattime"></span>
                  <div class="news_time">
                    {{news.createtime}}
                    </div>
                </div>
              </div>
            </mu-col>
            <mu-col class="news_link_box"  width="30" tablet="30" desktop="30">
              <div class="news_link middle" @click="getArticle(news.newsid)">
                {{$t('common.showMore')}}
                </div>
            </mu-col>
          </mu-row>
      <!--分页组件-->
      <div class="pagination_box"  v-if="total!=0">
        <mu-pagination :total="total" :current="current" :pageSize="pageSize" @pageChange="handleClick">
        </mu-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'article',
  metaInfo: {
    title: '赛事新闻_速得尔科技（北京）有限公司', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '赛事新闻，射击比赛，省运会，全运会，奥运会，速得尔'
    }, {                 // set meta
      name: 'description',
      content: '速得尔专注射击运动，全面报道全国各级别射击比赛'
    }]
  },
  data () {
    return {
      current: 1,
      pageIndex:1,
      pageSize:6,
      total:0,
      news:{}
    }
  },
  created(){
      this.id=this.$route.params.id||"1";
      this.reqArticleList();
  },
  methods:{
    getArticle(id){ //跳转到列表详情
      this.$router.push({name:"article",params:{id:id}});
    },
    handleClick(page){ //点击分页
       if(page!=this.pageIndex){
           this.pageIndex=page;
          this.reqArticleList();
       }
    },
    reqArticleList(){ //请求文章列表
      this.$http({
        root:'http://www.supershooter.cn:8099/webapi/news',
        method:'post',
        params:{
          pageIndex:this.pageIndex,
          pageSize:this.pageSize
        }
      }).then((res)=>{
        this.sw=true;
        if(res.body.code==200){
          this.news=res.body.data;
          this.total=res.body.count;
        }else{
          this.showErr(res);
        }
      },(res)=>{
        this.showErr(res);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #articles{
    background-color: #E6E6E6;
    overflow:hidden;
    clear:both;
   .article_box{
     margin-top:16px;
     margin-bottom:60px;
      background:#fff;
      padding:22px 55px;
     min-height:640px;
     .title{
       font-family: PingFangSC-Medium;
       display:inline-block;
       height:80px;
       padding:0px 4px;
       font-size: 16px;
       color: #3B3B3B;
       letter-spacing: 0;
       line-height: 80px;
       border-top:4px solid #2095D4;
       font-weight:600;
     }
   }
    .news_box{
      height:123px;
      margin-bottom:11px;
      background:#ffffff;
      padding:0px 37px;
      transition:all 500ms;
      &:hover{
        box-shadow: 0 8px 10px 0 rgba(0,0,0,0.09);
        cursor:pointer;
        .news_title{
          color: #21A1E5;
        }
      }
      .news_title{
        font-size: 18px;

        color: #3B3B3B;
        letter-spacing: 0;
        line-height: 16px;
        font-weight:600;
        line-height:24px;
        min-height:24px;
        padding:16px 0px;
      }
      .news_abstract{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #9398A1;
        letter-spacing: 0;
        line-height: 20px;
        min-height:30px;
      }
      .news_other{
        display:block;
        height:15px;
        line-height:15px;
        .icon_creattime{
          display:inline-block;
          width:15px;
          height:15px;
          background: url("../assets/images/clock-2.png") no-repeat center center;
          background-size:100% 100%;
          float:left;
        }
        .news_time{
          display:block;
          color: #9398A1;
          height:15px;
          line-height:16px;
          padding-left:10px;
          float:left;
        }


      }
      .news_link_box{
        position:relative;
        height:inherit;
        .news_link{
          display:block;
          border: 1px solid #2095D4;
          border-radius: 2px;
          width:120px;
          height:40px;
          line-height:40px;
          text-align:center;
          font-size: 14px;
          color: #2095D4;
          letter-spacing: 0;
          transition:all 500ms;
          cursor:pointer;
          &:hover{
            background: #21A1E5;
            color:#fff;
          }
        }
      }
    }
    .pagination_box{
      height:auto;
      margin: 0 auto;
      text-align:center;
    }
  }

</style>




// WEBPACK FOOTER //
// src/page/articlelist.vue